const { platformAppName, platformUrl } = require('./helpers/platform-domain')

module.exports = {
  appName: platformAppName(process.env.REACT_APP_APP_NAME),
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  imgixHost: process.env.REACT_APP_IMGIX_HOST,
  cloudimageHost: process.env.REACT_APP_CLOUDIMAGE_HOST,
  apiUrl: platformUrl(process.env.REACT_APP_API_URL)
}
